module.exports = __webpack_public_path__ + "img/myEstablish.d37d14df.svg";